export interface SalesPackDespatchItemAddRemove {
  salesPackId: string;
  salesDespatchItemId: string;
}
